import('./runInitFunc').then(() => import('./application'));
